import { get } from "lodash";
import { useSubscriptionDocumentAttachments } from "screens/Private/Broker/Subscription/hooks/useSubscriptionDocumentAttachments";
import Loading from "shared/components/Spin";
import { useMutation } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import {
  CREATE_ATTACHMENT,
  GENERATE_SUBSCRIPTION_DOCUMENTS,
} from "utils/api/graphql/mutations/attachment";
import {
  DOWNLOAD_DOCUMENT,
  DOWNLOAD_SINGLE_DOCUMENT,
} from "utils/api/graphql/mutations/download-document";
import { SEND_SUBSCRIPTION_ATTACHMENTS } from "utils/api/graphql/mutations/subscription";
import { DOCUMENTS_TYPES } from "utils/constants";
import View from "./View";

const Documents = ({ subscription, additionalInfoPercentage, setActive }) => {
  const [downloadSingleDocument] = useMutation(DOWNLOAD_SINGLE_DOCUMENT);
  const [downloadDocuments] = useMutation(DOWNLOAD_DOCUMENT);
  const [generateSubscriptionDocuments] = useMutation(
    GENERATE_SUBSCRIPTION_DOCUMENTS,
    {
      refetchQueries: [
        {
          query: graphql.queries.SUBSCRIPTION,
          awaitRefetchQueries: true,
          variables: { where: { id: get(subscription, "id") } },
        },
      ],
    },
  );
  const [sendSubscriptionAttachments] = useMutation(
    SEND_SUBSCRIPTION_ATTACHMENTS,
    {
      refetchQueries: [
        {
          query: graphql.queries.SUBSCRIPTION,
          awaitRefetchQueries: true,
          variables: { where: { id: get(subscription, "id") } },
        },
      ],
    },
  );
  const { attachments, loading } = useSubscriptionDocumentAttachments(
    subscription,
    {
      extraTypes: [
        DOCUMENTS_TYPES.QUOTE,
        DOCUMENTS_TYPES.DUTY_OF_ADVICE_QUOTE,
        DOCUMENTS_TYPES.DUTY_OF_ADVICE,
        DOCUMENTS_TYPES.MEMBERSHIP_FORM,
        DOCUMENTS_TYPES.SEPA_DIRECT_DEBIT_MANDATE,
        DOCUMENTS_TYPES.TERMINATION_LETTER,
        DOCUMENTS_TYPES.TERMINATION_MANDATE,
      ],
      step: null,
    },
  );

  const [addAttachment] = useMutation(CREATE_ATTACHMENT);

  if (loading) return <Loading />;

  return (
    <View
      data={attachments}
      additionalInfoPercentage={additionalInfoPercentage}
      setActive={setActive}
      sendAttachments={sendSubscriptionAttachments}
      addAttachment={addAttachment}
      subscription={subscription}
      downloadSingleDocument={downloadSingleDocument}
      downloadDocuments={downloadDocuments}
      generateSubscriptionDocuments={generateSubscriptionDocuments}
    />
  );
};

export default Documents;
